import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './../app/config-service.service'; // Import the service
import {FileUploadService} from './../app/file-upload.service';

export interface Review {
  // id?: number;
  userName: string;
  content: string;
  Page:string;
  rating: number;
  // createdAt?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ReviewService {
      apiUrl:string="";
  //  apiUrl = 'https://localhost:5001/api/reviews';
    requestPage:string=""
  constructor(private http: HttpClient,private configService: ConfigService,private fileUploadService: FileUploadService) {

    this.apiUrl=configService.getApiUrl()+"/review";
    this.fileUploadService.currenticonIdentifierRequest.subscribe(selectedIconIdentifireRequest => this.requestPage = selectedIconIdentifireRequest);

   }

  // getReviews(): Observable<Review[]> {
  //   return this.http.get<Review[]>(this.apiUrl);
  // }

  getReviews(pageType: string): Observable<Review[]> {
    const url = `${this.apiUrl}/${pageType}`; // Append parameter to API URL
    return this.http.get<Review[]>(url);
  }

  addReview(review: Review): Observable<Review> {
    
    review.Page=this.requestPage;
    return this.http.post<Review>(this.apiUrl, review);
  }

}
